import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiLinksSectionDTO,
  LinksSectionDTO,
} from "@lib/strapi/dtos/components/sections/linksSection.dto";
import { LinkService } from "@lib/strapi/services/components/shared/link.service";

export class LinksSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiLinksSectionDTO,
  ): Promise<LinksSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new LinksSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.title = strapiData.title;
    dto.links = await Promise.all(
      (strapiData.links ?? []).map(
        async (item) => await LinkService.fromStrapi(locale, item),
      ),
    );
    return dto;
  }
}
